import React, { SyntheticEvent, useCallback, useRef, useState } from 'react';
import { Row, Col, Button, FormControl } from 'react-bootstrap';
import { Waypoint } from 'react-waypoint';

import { useSearchProductQuery } from 'src/generated/graphql';
import { useConfig } from '@server/lib/config';

import { Title, Wrapper, ProductContainer } from './styled';
import Products from './products';

const PAGE_SIZE = 10;
let timer = null;

const QuotationProduct = () => {
  const { API_ENDPOINT } = useConfig();

  const QUOTATION_ENDPOINT = `${API_ENDPOINT}/v2/web/export-product-quote`;
  const [products, setProducts] = useState([]);
  const [noMoreResult, setNoMoreResult] = useState(false);
  const [filter, setFilter] = useState({
    keyword: null,
    isQuotation: true,
    limit: PAGE_SIZE,
    page: 1,
  });

  const { data, loading, error } = useSearchProductQuery({
    variables: {
      filter,
    },
    onCompleted: (data) => {
      return (
        data.searchProductV2.products &&
        (data.searchProductV2.products.length > 0
          ? setProducts(products.concat(data.searchProductV2.products))
          : setNoMoreResult(true))
      );
    },
  });

  const handleLoadMore = () =>
    setFilter((prev) => {
      prev = { ...prev, page: prev.page + 1 };

      return prev;
    });

  const [downloading, setDownloading] = useState<boolean>(false);
  const downloadRef = useRef<any>();
  const onDownload = useCallback((event: SyntheticEvent) => {
    event.preventDefault();
    setDownloading(true);
    const a = document.createElement('a');
    a.href = QUOTATION_ENDPOINT;
    a.download = QUOTATION_ENDPOINT.split('/').pop();
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    downloadRef.current = setTimeout(() => {
      setDownloading(false);

      clearTimeout(downloadRef.current);
    }, 10000);
  }, []);

  const onChangeKeyword = useCallback((event: any) => {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }

    const value = event.target.value;
    timer = setTimeout(() => {
      setProducts([]);
      setNoMoreResult(false);
      setFilter((prev) => {
        prev = { ...prev, keyword: value || '', page: 1 };

        return prev;
      });

      if (window && window.dataLayer) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          EventCategory: 'Search Bao Gia',
          EventAction: 'form_submit',
          EventLabel: value,
        });
        window.dataLayer.push({ event: 'SendEvent' });
      }
    }, 1000);
  }, []);

  return (
    <Wrapper>
      <Title>FAST - BÁO GIÁ VĂN PHÒNG PHẨM NHANH HƠN</Title>
      <form>
        <Row>
          <Col md={8}>
            <FormControl
              placeholder="Nhập tên sản phẩm tìm kiếm"
              onChange={onChangeKeyword}
              className="mb-4"
            />
          </Col>
          <Col md={4} className="text-right">
            <Button
              disabled={downloading}
              type="button"
              variant="primary"
              onClick={onDownload}
              style={{ width: '100%' }}
            >
              {downloading ? 'Đang tải..' : 'Download bảng báo giá'}
            </Button>
          </Col>
        </Row>

        <ProductContainer>
          <Products products={products} />

          {loading || error ? (
            <div className="mt-2">Đang tải...</div>
          ) : (
            <>
              {noMoreResult ? (
                <div className="mt-2" style={{ display: 'none' }}>
                  Tất cả sản phẩm đã hiển thị{' '}
                  <pre>{JSON.stringify(filter)}</pre>
                </div>
              ) : (
                <div className="mt-2" style={{ height: '100px' }}>
                  <Waypoint onEnter={() => handleLoadMore()} topOffset={50} />
                </div>
              )}
            </>
          )}
        </ProductContainer>
      </form>
    </Wrapper>
  );
};

const Container = React.memo(QuotationProduct);
Container.displayName = 'QuotationProduct';

export default Container;
